import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import { solid, brands, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Toast } from "primereact/toast";
import tagManagerEvents from "../utils/GoogleTagManager";

export interface FavouriteCardProps {
  data: any;
  utm_source?: string;
  courseId?: string | number;
  removeBookMark: () => void;
}

export default function FavouriteCard(props: FavouriteCardProps) {
  const toast = useRef<any>(null);
  const MySwal = withReactContent(Swal);

  const _copy = (data: string) => {
    navigator.clipboard
      .writeText(data)
      .then((resp) => {
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Copied",
            detail: "Url copied to clipboard",
            life: 3000,
          });
        }
        console.log(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const _share = () => {
    let data = props.data;
    console.log(data);
    tagManagerEvents("Share", props.utm_source);
    if (navigator.share) {
      if (data.chapterNumber) {
        navigator.share({
          title: data.title,
          text: data.title,
          url: data.videoId
            ? window.location.protocol +
              "//" +
              window.location.host +
              "/course_detail?courseId=" +
              data.course_id +
              "&chapterId=" +
              data.chapter_id +
              "&courseVideoId=" +
              data.videoId
            : window.location.protocol +
              "//" +
              window.location.host +
              "/course_detail?courseId=" +
              data.course_id +
              "&chapterId=" +
              data.chapter_id,
        });
      } else {
        navigator.share({
          title: data.title,
          text: data.description,
          url:
            window.location.protocol +
            "//" +
            window.location.host +
            "/course_detail?courseId=" +
            data.course_id +
            "&videoId=" +
            data.videoId,
        });
      }
    } else {
      MySwal.fire({
        title: <p>Share on Social Media</p>,
        confirmButtonColor: "#c10009",
        confirmButtonText: "close",
        html: (
          <div>
            <a
              target="_blank"
              rel="noreferrer"
              className="text-success"
              onClick={() => MySwal.close()}
              href={
                data.chapterNumber
                  ? data.videoId
                    ? "https://api.whatsapp.com/send?text=Title: " +
                      data.title +
                      "%0aUrl: " +
                      window.location.protocol +
                      "//" +
                      window.location.host +
                      "/course_detail?courseId=" +
                      data.course_id +
                      "&chapterId=" +
                      data.chapter_id +
                      "&courseVideoId=" +
                      data.videoId
                    : "https://api.whatsapp.com/send?text=Title: " +
                      data.title +
                      "%0aUrl: " +
                      window.location.protocol +
                      "//" +
                      window.location.host +
                      "/course_detail?courseId=" +
                      data.course_id +
                      "&chapterId=" +
                      data.chapter_id
                  : "https://api.whatsapp.com/send?text=Title: " +
                    data.title +
                    "%0aUrl: " +
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/course_detail?courseId=" +
                    data.course_id +
                    "&videoId=" +
                    data.videoId
              }
            >
              <FontAwesomeIcon className="fa-3x" icon={brands("whatsapp")} />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              className="text-blue ms-2"
              onClick={() => MySwal.close()}
              href={
                data.chapterNumber
                  ? data.videoId
                    ? "https://www.facebook.com/dialog/send?app_id=1405438406631984&link=" +
                      encodeURIComponent(
                        window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          data.course_id +
                          "&chapterId=" +
                          data.chapter_id
                      ) +
                      "&redirect_uri=" +
                      encodeURIComponent(
                        window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          data.course_id +
                          "&chapterId=" +
                          data.chapter_id +
                          "&courseVideoId=" +
                          data.videoId
                      )
                    : "https://www.facebook.com/dialog/send?app_id=1405438406631984&link=" +
                      encodeURIComponent(
                        window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          data.course_id +
                          "&chapterId=" +
                          data.chapter_id
                      ) +
                      "&redirect_uri=" +
                      encodeURIComponent(
                        window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          data.course_id +
                          "&chapterId=" +
                          data.chapter_id
                      )
                  : "https://www.facebook.com/dialog/send?app_id=1405438406631984&link=" +
                    encodeURIComponent(
                      window.location.protocol +
                        "//" +
                        window.location.host +
                        "/course_detail?courseId=" +
                        data.course_id +
                        "&videoId=" +
                        data.videoId
                    ) +
                    "&redirect_uri=" +
                    encodeURIComponent(
                      window.location.protocol +
                        "//" +
                        window.location.host +
                        "/course_detail?courseId=" +
                        data.course_id +
                        "&videoId=" +
                        data.videoId
                    )
              }
            >
              <FontAwesomeIcon className="fa-3x" icon={brands("facebook")} />
            </a>

            <div className="p-2 mt-4 bg-light d-flex justify-content-between align-items-center">
              <input
                type="text"
                size={45}
                readOnly
                className="form-control"
                value={
                  data.chapterNumber
                    ? window.location.protocol +
                      "//" +
                      window.location.host +
                      "/course_detail?courseId=" +
                      props.courseId +
                      "&chapterId=" +
                      data.id
                    : window.location.protocol +
                      "//" +
                      window.location.host +
                      "/course_detail?courseId=" +
                      data.course.id +
                      "&videoId=" +
                      data.id
                }
              />
              <span
                className="cursor-pointer text-red w-50"
                onClick={() => {
                  _copy(
                    data.chapterNumber
                      ? window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          props.courseId +
                          "&chapterId=" +
                          data.id
                      : window.location.protocol +
                          "//" +
                          window.location.host +
                          "/course_detail?courseId=" +
                          data.course.id +
                          "&videoId=" +
                          data.id
                  );
                }}
              >
                {/* <FontAwesomeIcon icon={regular("copy")} /> COPY */}
              </span>
            </div>
          </div>
        ),
      });
    }
  };

  return (
    <>
      <Toast ref={toast} position="bottom-right" />

      <div className="card shadow border-0 h-100 br-card position-relative">
        <div className="course-card-img position-relative">
          <a
            href={
              props.data.isCollar
                ? "/course_detail?courseId=" +
                  props.data.course_id +
                  "&videoId=" +
                  props.data.videoId
                : props.data.videoId
                ? "/course_detail?courseId=" +
                  props.data.course_id +
                  "&chapterId=" +
                  props.data.chapter_id +
                  "&courseVideoId=" +
                  props.data.videoId
                : "/course_detail?courseId=" +
                  props.data.course_id +
                  "&chapterId=" +
                  props.data.chapter_id
            }
          >
            <div className="overlay justify-content-center align-items-center"></div>
          </a>
          <img
            src={props.data.thumbnail}
            className="card-img-top h-200px"
            alt="img"
          />
        </div>
        <div className="card-body">
          <div className="row my-1">
            <div className="col-9">
              <p className="mb-2 font-12 text-muted text-truncate _title">
                <FontAwesomeIcon icon={solid("book")} className="me-1" />
                {props.data.chapterNumber
                  ? "Chapter " + props.data.chapterNumber
                  : props.data.title}
              </p>
            </div>
            <div className="col-3">
              <span>
                <FontAwesomeIcon
                  icon={solid("share")}
                  onClick={_share}
                  className="text-red mb-3 _hover cursor-pointer _hover "
                />
                <FontAwesomeIcon
                  icon={solid("heart")}
                  className="float-end color-red _hover"
                  onClick={props.removeBookMark}
                />
              </span>
            </div>
          </div>

          <p className="fw-bold font-15">{props.data.title}</p>
          <a
            href={
              props.data.isCollar
                ? "/course_detail?courseId=" +
                  props.data.course_id +
                  "&videoId=" +
                  props.data.videoId
                : props.data.videoId
                ? "/course_detail?courseId=" +
                  props.data.course_id +
                  "&chapterId=" +
                  props.data.chapter_id +
                  "&courseVideoId=" +
                  props.data.videoId
                : "/course_detail?courseId=" +
                  props.data.course_id +
                  "&chapterId=" +
                  props.data.chapter_id
            }
            className="btn btn-red _hover px-5 font-12"
          >
            Details
          </a>
        </div>
      </div>
    </>
  );
}
